import { render, staticRenderFns } from "./reporteDespachados.vue?vue&type=template&id=321c4b00"
import script from "./reporteDespachados.vue?vue&type=script&lang=js"
export * from "./reporteDespachados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports